export * from './app-init.service';
export { default as appInitService } from './app-init.service';
